/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type CurrencyEnum = 1 | 2 | 3 | 4;

export const CurrencyEnum = {
    NUMBER_1: 1 as CurrencyEnum,
    NUMBER_2: 2 as CurrencyEnum,
    NUMBER_3: 3 as CurrencyEnum,
    NUMBER_4: 4 as CurrencyEnum
};